import React, { useContext } from 'react';

import { resetApplicationContext } from '@/contexts/ApplicationContext/actions/resetApplicationContext';
import { setLoading } from '@/contexts/ApplicationContext/actions/setLoading';
import { setShowSummary } from '@/contexts/ApplicationContext/actions/setShowSummary';
import { updateApplicationContext } from '@/contexts/ApplicationContext/actions/updateApplicationContext';
import { ApplicationContextInitialState } from '@/contexts/ApplicationContext/state/ApplicationContextInitialState';

export const applicationState = {
  ...ApplicationContextInitialState,

  // general
  showMobileSummary: false as boolean,
  isDirty: false as boolean,
  isCompleted: false as boolean,
  loading: undefined as boolean | undefined,
};

export type applicationContextState = typeof applicationState;

const actionsDefinitions = (setStateById: (id: string, stateChange: stateChangeInApplicationContext) => void) => ({
  updateApplicationContext: updateApplicationContext(setStateById),
  resetApplicationContext: resetApplicationContext(setStateById),
  setLoading: setLoading(setStateById),
  setShowSummary: setShowSummary(setStateById),
});

const ApplicationContext = React.createContext({
  state: applicationState,
  actions: actionsDefinitions(() => () => {}),
});

export type action = (setState: setStateInApplicationContext, actionId: string) => () => void;

export type setApplicationStateById = (id: string, stateChange: stateChangeInApplicationContext) => void;
export type stateChangeInApplicationContext = (prevState: applicationContextState) => applicationContextState;
export type setStateInApplicationContext = React.Dispatch<stateChangeInApplicationContext>;

export const useApplicationContext = () => useContext(ApplicationContext);

export function ApplicationContextProvider(props) {
  const [state, setState] = React.useState(applicationState);
  const setStateById: setApplicationStateById = (_, stateChange) => {
    setState(stateChange);
  };

  const actions = actionsDefinitions(setStateById);
  return <ApplicationContext.Provider value={{ state, actions }}>{props.children}</ApplicationContext.Provider>;
}
